import { sidebarSize, topbarSize } from '../../../constants/sizes';
import Device from '../../../constants/deviceSizes';

export default {
  base: {
    textAlign: 'center',
    display: 'flex',
    height: '100vh'
  },
  content: {
    height: `calc(100% - ${topbarSize}px)`,
    marginLeft: sidebarSize,
    marginTop: topbarSize,
    width: `calc(100% - ${sidebarSize}px)`,
    [Device.tablet_mobile]: {
      width: '100%',
      marginLeft: 0
    }
  },
  baseContent: {
    width: '100%',
    flex: 4
  }
};
